import React, { Component } from 'react';
import { Button, Panel, Glyphicon, ButtonToolbar, Table, Row, Modal, FormControl, ControlLabel, FormGroup } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { LineColorShadeForm } from './LineColorShadeForm';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { HandleDialog } from '../../../HandleDialog';
import { HandleMessage } from '../../../HandleMessage';
import { TableButton } from '../../../TableButton';

export class LineColorShades extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            shadeSelected: { seq: '', val: '' },
            index: undefined,
            generateShades: 'claras',
            showLineColorShadeForm: false,
            showGenerateConfirmationModal: false,
            showDeleteModal: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false,
        }
    }

    handleCreateClick = () => {
        if (this.props.lineColorSelected.shades.length < 5) {
            this.setState({
                shadeSelected: { seq: '', val: '' },
                showLineColorShadeForm: true,
                title: 'Criar'
            })
        } else {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: 'O limite de 5 tonalidades por cor foi atingido.',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            })
        }
    }

    handleGenerateClick = () => {
        let { lineColorSelected } = this.props;
        let { generateShades } = this.state;

        lineColorSelected.shades = [];

        var z = 0;
        var deltaR = 'claras' === generateShades ? 255 - lineColorSelected.backColor.r : lineColorSelected.backColor.r;
        var deltaG = 'claras' === generateShades ? 255 - lineColorSelected.backColor.g : lineColorSelected.backColor.g;
        var deltaB = 'claras' === generateShades ? 255 - lineColorSelected.backColor.b : lineColorSelected.backColor.b;

        for (var i = 10; i <= 51; i += 10) {
            var newShade = { seq: '', val: '' };
            if ('claras' === generateShades) {
                newShade.seq = z++;
                newShade.val = {
                    r: Math.round(lineColorSelected.backColor.r + deltaR * i / 100),
                    g: Math.round(lineColorSelected.backColor.g + deltaG * i / 100),
                    b: Math.round(lineColorSelected.backColor.b + deltaB * i / 100),
                    a: 1
                }
                this.props.onCreateShadeValue(newShade)
            } else {
                newShade.seq = z++;
                newShade.val = {
                    r: Math.round(lineColorSelected.backColor.r - deltaR * i / 100),
                    g: Math.round(lineColorSelected.backColor.g - deltaG * i / 100),
                    b: Math.round(lineColorSelected.backColor.b - deltaB * i / 100),
                    a: 1
                }
                this.props.onCreateShadeValue(newShade)
            }
        }
    }

    getConfirmation = () => {
        return (
            <Modal show={this.state.showGenerateConfirmationModal}>
                <Modal.Body className="padding-0">
                    <Panel bsStyle="warning" className="margin-bottom-0 border-0" >
                        <Panel.Heading>
                            <h3 className="alert-title">
                                <Glyphicon glyph='alert' />
                                &nbsp;&nbsp; Aviso
                        </h3>
                        </Panel.Heading>

                        <Panel.Body>
                            <div>
                                <div className="padding-top-20 padding-bottom-20 font-size-12 break-word">
                                    Todas as tonalidades existentes serão substituídas. Deseja continuar?
                            </div>
                                <div className="pull-right">
                                    <Button onClick={() => this.setState({ showGenerateConfirmationModal: false }, () => this.handleGenerateClick())}> SIM </Button>
                                    &nbsp;
                                <Button onClick={() => this.setState({ showGenerateConfirmationModal: false })}> NÃO </Button>
                                </div>
                            </div>
                        </Panel.Body>
                    </Panel>
                </Modal.Body>
            </Modal>
        )
    }

    handleEditClick = (shade, idx) => {
        this.setState({
            shadeSelected: shade,
            index: idx,
            showLineColorShadeForm: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (shade, idx) => {
        this.setState({
            shadeSelected: shade,
            index: idx,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende esta tonalidade?`,
            icon: 'alert',
            alertStyle: "warning"
        })
    }

    deleteShade = (isToExecute) => {
        if (isToExecute) {
            this.props.onRemoveShadeValue(this.state.index);
        }
        this.setState({
            showDeleteModal: false
        })
    }

    onChangeValue = (e) => {
        let { shadeSelected } = this.state;

        shadeSelected.val = e.rgb;

        this.props.onCreateShadeValue(shadeSelected);

        this.setState({
            shadeSelected
        })
    }

    clearError = () => {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false
        })
    }

    handleHide = () => {
        this.setState({
            showLineColorShadeForm: false,
            shadeSelected: undefined,
            showGenerateShadeForm: false,
        });
    }

    renderShadesTable(shades) {
        return (
            <div className="table-small-screens">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Cor</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            shades.length !== 0
                                ?
                                shades.map((shade, idx) =>
                                    shade !== undefined && shade.val !== undefined
                                        ?
                                        <tr key={`shade-${idx}`}>
                                            <td>
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${shade.val.r}, ${shade.val.g}, ${shade.val.b}, ${shade.val.a})`
                                                        }
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <ButtonToolbar>
                                                    <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(shade, idx)} />
                                                    <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(shade, idx)} />
                                                </ButtonToolbar>
                                            </td>
                                        </tr>
                                        :
                                        ''
                                )
                                :
                                null
                        }
                    </tbody>
                </Table >
            </div>
        );
    }

    render() {
        let { lineColorSelected } = this.props;
        let contents = (lineColorSelected === undefined)
            ? <LoadingSpinner />
            : this.renderShadesTable(lineColorSelected.shades);

        let generateConfirmation = this.state.showGenerateConfirmationModal ? this.getConfirmation() : '';

        return (
            <Modal show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>
                        Gerir Tonalidades
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            {contents}
                        </div>

                        <div>
                            {generateConfirmation}
                        </div>

                        <FormGroup controlId="formGerarAutomaticamente">
                            <ControlLabel>Gerar Automaticamente</ControlLabel>
                            <FormControl componentClass="select" onChange={(e) => this.setState({ generateShades: e.target.value })}>
                                <option key={`claras`} value='claras'>Tonalidades claras</option>
                                <option key={`escuras`} value='escuras'>Tonalidades escuras</option>
                            </FormControl>
                        </FormGroup>


                        <Row className="btns-small-screens-inside-modal padding-left-15">
                            <ButtonToolbar>
                                <Button onClick={this.handleCreateClick}>
                                    CRIAR
                                </Button>
                                <Button onClick={() => this.setState({ showGenerateConfirmationModal: true })}>
                                    GERAR AUTOMATICAMENTE
                                </Button>
                                <Button onClick={this.props.onHide}>
                                    CONCLUÍDO
                                </Button>
                            </ButtonToolbar>
                        </Row>
                    </div>
                </Modal.Body>
                <LineColorShadeForm show={this.state.showLineColorShadeForm} title={this.state.title} lineColorSelected={lineColorSelected} shadeSelected={this.state.shadeSelected} index={this.state.index}
                    onChangeValue={this.onChangeValue} onEditShadeValue={this.props.onEditShadeValue} onHide={this.handleHide} />
                <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} argument={this.state.shadeSelected} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteShade} />
            </Modal >
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lineColors/lineColorShades/LineColorShades.js